var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBold = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 4.42105C4.5 3.63623 5.1296 3 5.90625 3H13.4063C14.7738 3 16.0853 3.54896 17.0523 4.52613C18.0193 5.50329 18.5625 6.82861 18.5625 8.21053C18.5625 9.44048 18.1322 10.6256 17.3557 11.5603C17.5798 11.7233 17.792 11.9052 17.9898 12.1051C18.9568 13.0822 19.5 14.4076 19.5 15.7895C19.5 17.1714 18.9568 18.4967 17.9898 19.4739C17.0228 20.451 15.7113 21 14.3438 21H5.90625C5.1296 21 4.5 20.3638 4.5 19.5789V4.42105ZM13.4145 13.4211C13.4117 13.4211 13.409 13.4211 13.4063 13.4211L7.3125 13.4211V18.1579H14.3438C14.9653 18.1579 15.5615 17.9084 16.001 17.4642C16.4406 17.02 16.6875 16.4176 16.6875 15.7895C16.6875 15.1613 16.4406 14.5589 16.001 14.1147C15.5615 13.6706 14.9654 13.421 14.3438 13.421L13.4145 13.4211ZM7.3125 10.5789L13.4063 10.579C13.4081 10.579 13.41 10.5789 13.4118 10.5789C14.0314 10.5775 14.6253 10.3281 15.0635 9.88526C15.5031 9.44109 15.75 8.83867 15.75 8.21053C15.75 7.58238 15.5031 6.97997 15.0635 6.5358C14.624 6.09164 14.0279 5.84211 13.4063 5.84211H7.3125V10.5789Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBold);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bold.9d9be9b31128bb90acd415ca47028a5f.svg";